import { axios } from '@/utils/request'

const api = {
    addRobot: '/5db6b20a0b5a6',
    removeRobot: '/5dddd7ae9f078',
    getList: '/5db80fa95a19a'
}

export default {
    // 获取列表
    getList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 200
        })
        return axios({
            url: api.getList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },
    // 新增项目
    addRobot: (parameter) => {
        const params = parameter
        return axios({
            url: api.addRobot,
            method: 'post',
            data: params
        })
    },
    // 移除项目
    removeRobot: (parameter) => {
        const params = parameter
        return axios({
            url: api.removeRobot,
            method: 'post',
            data: params
        })
    }
}
